import { render, staticRenderFns } from "./verifiedOtherQh.vue?vue&type=template&id=53315b27&"
import script from "./verifiedOtherQh.vue?vue&type=script&lang=js&"
export * from "./verifiedOtherQh.vue?vue&type=script&lang=js&"
import style0 from "./verifiedOtherQh.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports